import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-collective-user-dashboard',
  templateUrl: './collective-user-dashboard.component.html',
  styleUrls: ['./collective-user-dashboard.component.scss']
})
export class CollectiveUserDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
